import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import ApiService from "../../_services/ApiService";

import "./register-centre.styles.css";
import UserService from "../../_services/UserService";

const RegisterCentre = () => {
  const { testId } = useParams();
  const location = useLocation();
  const {testStartDate, testName} = location?.state || {};
  const history = useHistory();
  const [centres, setCentres] = useState([]);
  const [centreId, setCentreId] = useState(null);
  const [successfulReg, setSuccesfulReg] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    console.log(testId);
    const fetchCentres = async () => {
      try {
        const centresData = await ApiService.fetchCentresData(testId);
        console.log(centresData?.data);
        setCentres(centresData?.data?.centres);
      } catch (err) {
        console.log(err);
      }
    };
    fetchCentres();
  }, []);

  const handleChangeSelect = (e) => {
    const { value } = e.target;
    setCentreId(value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (centreId === "-1") {
      console.log(testStartDate);
      setAlertMessage(
        `No Worries! Come back on the exam day ${testStartDate === "--" || !testStartDate?"": "(" + testStartDate + ")"} to the same portal and you can take this exam Online.`
      );
      return;
    }
    const body = {
      testId,
      userId: UserService.getUserId(),
      centreId,
    };
    console.log(body);
    try {
      const res = await ApiService.saveCentreDetails(body);
      console.log(res);
      if (res.data.status === 201) {
        setSuccesfulReg(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCentreDetailsById = (id)=>{
    console.log(centres);
    for(let centre of centres){
      if(centre.centreId === id) return centre
    }

    return null
    
  }

  const redirectToAdmitCard = ()=>{
    const centreDetails = getCentreDetailsById(centreId);
    console.log(centreDetails);
    history.replace("/admitcard",{
      testTime: testStartDate,
      testName,
      centreName: centreDetails?.centreName,
      centreAddress: centreDetails?.address,
    })
  }

  return (
    <div>
      <div className={`module-header-step2 test-list-default-portlet`}>
        <div className="">
          <div className="back">
            <FontAwesomeIcon icon={faArrowLeft} onClick={history.goBack} />
          </div>
          <h4>Register centre</h4>
        </div>
      </div>
      <div className="register-centre-form-wrapper">
        {successfulReg ? (
          <div className="register-centre-success-wrapper">
            <span className="register-centre-tick">&#10004;</span>
            <span className="register-centre-success-text">
              Your registration was successful! Click{" "}
              <span
                className="register-centre-clickable-text"
                onClick={redirectToAdmitCard}
              >
                here
              </span>{" "}
              to download your admit card
            </span>
          </div>
        ) : (
          <div>
            <form className="register-centre-form" onSubmit={handleFormSubmit}>
              <div className="test-result-application-div">
                <label className="register-centre-text-width">
                The following centres are <span className="register-centre-bold">currently open</span> for registration for writing the {testStartDate === "--" || !testStartDate?"": testStartDate} Test Offline. Select your centre and print your admit card.
                </label>
                <select
                  className="user-registration-select"
                  name="centreId"
                  onChange={handleChangeSelect}
                  required
                  disabled={alertMessage}
                >
                  <option disabled selected value="">
                    {" "}
                    -- select an option --{" "}
                  </option>
                  {centres?.map((centre) =>
                    Number(centre.registeredStudents) <
                    Number(centre.maxCapacity) ? (
                      <option id={centre.centreId} value={centre.centreId}>
                        {centre.centreName}
                      </option>
                    ) : null
                  )}
                  <option value="-1">My preferred centre is Not available</option>
                </select>

                <button className="btn btn-success" disabled={alertMessage}>
                  Submit
                </button>
              </div>
            </form>
            {
              alertMessage&&
            <span className="register-centre-red-text">* {alertMessage}</span>
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default RegisterCentre;
